export default __webpack_public_path__ + "images/logic-edit-profile-stones.svg";